/**
 * Automatically set key in context by renderer in cli.mts and createHtmlTemplate.ts
 * Contains the tenant of the current page/template
 */
export const tenantContextKey = "tenant";
